export function portalLinks(input) {
    const origin = input.appBaseUrl?.replace(/\/+$/, '') || '';
    return {
        portalHref: input.landingUrl || `${origin}/`,
        adminHref: input.isAdmin ? (origin ? `${origin}/admin` : '/admin/') : undefined,
        documentsHref: `${origin}/me/documents`,
        integrationsHref: `${origin}/me/integrations`,
        schedulesHref: `${origin}/admin/schedules`,
        accountHref: `${origin}/me/account`,
    };
}
//# sourceMappingURL=portal-links.js.map